import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Layout from 'components/layout';
import Box from 'components/box';
import Head from 'components/head';

const Imprint = ({ data }) => (
  <Layout>
    <Head pageTitle={data.imprintJson.title} />
    <Box>
      <div
        dangerouslySetInnerHTML={{
          __html: data.imprintJson.content.childMarkdownRemark.html,
        }}
      />
    </Box>
  </Layout>
);

Imprint.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Imprint;

export const query = graphql`
  query ImprintQuery {
    imprintJson {
      title
      content {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`;
